"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaseListSheetButton = CaseListSheetButton;
const react_1 = __importStar(require("react"));
const CommonComponents_1 = require("../../View/Resultsets/CommonComponents");
const CaseListSheetModal_1 = require("./CaseListSheetModal");
/**
 * Akcja kontraktu: generowanie „Spisu spraw" — arkusza Google z drzewem
 * kamienie → sprawy → podsprawy → zadania (nazwy, statusy, uwagi).
 *
 * Arkusz trafia do podfolderu „Spisy spraw" w folderze GD kontraktu, a nazwa pliku
 * koduje konfigurację: to samo ustawienie nadpisuje swój arkusz, inne tworzy nowy obok.
 */
function CaseListSheetButton({ dataObject, layout }) {
    // Właściciele zadań w tym kontrakcie — wyliczani przy budowie drzewa (buildTree),
    // dzięki czemu lista nie zawiera osób, dla których spis byłby pusty.
    const taskOwners = (dataObject._taskOwners ?? []);
    const gdFolderId = dataObject.gdFolderId;
    const [show, setShow] = (0, react_1.useState)(false);
    if (!gdFolderId)
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(CommonComponents_1.CaseListIconButton, { layout: layout, onClick: () => setShow(true) }),
        react_1.default.createElement(CaseListSheetModal_1.CaseListSheetModal, { show: show, onHide: () => setShow(false), scope: {
                action: "contractCaseListSheet",
                target: { contractId: dataObject.id },
                subtitle: "Arkusz Google z drzewem kamieni, spraw i zadań - trafi do podfolderu „Spisy spraw\" w folderze kontraktu.",
                allPersonsLabel: "Wszystkich osób (cały kontrakt)",
                noOwnersNote: "W tym kontrakcie nie ma zadań przypisanych do konkretnych osób.",
                noSelfTasksNote: "Nie masz zadań w tym kontrakcie - spis pokaże tylko zadania nieprzypisane.",
                taskOwners,
            } })));
}
